<script>
import {api} from "@/modules/api";

export default {
  name: 'ViewOrderSuccess',
  data () {
    return {
      cart: {},
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  mounted () {
    this.loadData()
  },
  computed: {
    formatDate () {
      const date = new Date(this.cart.orderAt)
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${date.getFullYear()}`
    },
    formatDateLivraison () {
      const date = new Date(this.cart.orderAt)
      return `${(date.getDate() + 7).toString().padStart(2, '0')}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${date.getFullYear()}`
    }
  },
  methods: {
    loadData () {
      api.cart.getById(this.$route.params.id).then((res) => {
        this.cart = res
      })
    }
  }
}
</script>

<template>
  <section v-if="cart.users" class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <div class="mx-auto max-w-2xl px-4 2xl:px-0">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl mb-2">
        Merci pour votre commande
      </h2>
      <p class="text-gray-500 dark:text-gray-400 mb-6 md:mb-8">
        Your order
        <a :href="'/mes-commandes/' + cart.id" class="font-medium text-gray-900 dark:text-white hover:underline">
          #{{ cart.numberOrder }}
        </a>
        will be processed within 24 hours during working days. We will notify you by email once your order has been shipped.
      </p>
      <div class="space-y-4 sm:space-y-2 rounded-lg border border-gray-100 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800 mb-6 md:mb-8">
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Date de commande</dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">
            {{ formatDate }}
          </dd>
        </dl>
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Date de Livraison prévu</dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">
            {{ formatDateLivraison }}
          </dd>
        </dl>
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Moyen de paiement</dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">Carte bancaire</dd>
        </dl>
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">Nom</dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">
            {{ cart.users.lastname }} {{ cart.users.firstname }}
          </dd>
        </dl>
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">
            Adresse de livraison
          </dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">
            {{  cart.deliveryAddresses.numberRoute }} {{  cart.deliveryAddresses.route }}, {{  cart.deliveryAddresses.zipcode }} {{  cart.deliveryAddresses.city }}, {{  cart.deliveryAddresses.country }}
          </dd>
        </dl>
        <dl class="sm:flex items-center justify-between gap-4">
          <dt class="font-normal mb-1 sm:mb-0 text-gray-500 dark:text-gray-400">
            Numéro de téléphone
          </dt>
          <dd class="font-medium text-gray-900 dark:text-white sm:text-end">
            {{ cart.users.phone }}
          </dd>
        </dl>
      </div>
      <div class="flex items-center space-x-4">
        <a :href="'/mes-commandes/' + cart.id" class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800">
          Suivez votre commande
        </a>
        <a href="/" class="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
          Retourner sur le site
        </a>
        <a :href="apiUrl +'/pdf/bon-de-commande/' + cart.id" target="_blank" class="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
          Télécharger ma facture
        </a>
      </div>
    </div>
  </section>
</template>
